/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'

import ButtonGroup from '../../../components/ButtonGroup'
import TimePicker from '../../../components/TimePicker'
import { TRCInput } from '../../../trace'

import './EditGameInfo.css'

/*
 * Props
 *
 * gameDate
 * gameTime
 * gameDateChanged
 * GameTimeChanged
 * halfLength
 * halfLengthChanged
 * caseId
 * caseIdChanged
 */

export default class EditGameInfo extends Component {

    constructor(props) {
        super(props)

        this.halfLengths = [25, 30, 35, 40, 45]
    }

    render() {
        var styles = {}
        if (this.props.show === false) {
            styles = { display: 'none' }
        }
        console.log('EditGameInfo.camera', this.props.camera, this.props.gameDate)
        // value={this.props.gameDate !== '1970-01-01' ? this.props.gameDate : '2019-04-09' }

        return (
            <div style={styles} className="EditGameInfo">
                <div className="trc-grid">
                    <p className="col m-ff12 date">
                        <label>Game Date</label>
                        <input
                            type="date"
                            onChange={this.props.gameDateChanged}
                            value="2019-01-03"
                            className="trace-input" />
                    </p>
                    <p className="col m-ff12">
                        <label>Game Time</label>
                        <TimePicker
                            onChange={this.props.gameTimeChanged}
                            value={this.props.gameTime} />
                    </p>
                    <p className="half-length col m-ff12">
                        <label>Half Length</label>
                        <ButtonGroup
                            type="radio"
                            onChange={this.props.halfLengthChanged}
                            value={this.props.halfLength} >
                            { this.halfLengths.map((hl, ix) => (<button key={ix} value={hl}>{hl}</button>)) }
                        </ButtonGroup>
                    </p>
                    { this.props.camera === false && (
                        <p className="col m-ff12 case-id">
                            <label>Case ID</label>
                            <TRCInput
                                id="input_pi_id"
                                type="text"
                                name="pi_id"
                                onChange={this.props.piIdChanged}
                                value={this.props.piId} />
                        </p>
                    )}
                </div>
                <div className="trc-grid">
                    { this.props.camera === true && (
                        <p className="col m-ff12 case-id">
                            <label>Case ID</label>
                            <TRCInput
                                id="input_pi_id"
                                type="text"
                                name="pi_id"
                                onChange={this.props.piIdChanged}
                                value={this.props.piId} />
                        </p>
                    )}
                    { this.props.camera === true && (
                        <p className="col m-ff12 case-id">
                            <label>Camera ID</label>
                            <TRCInput
                                id="input_camera_id"
                                type="text"
                                name="camera_id"
                                onChange={this.props.cameraIdChanged}
                                value={this.props.cameraId} />
                        </p>
                    )}
                </div>
            </div>
        )
    }

}
